module.exports = __webpack_public_path__ + "img/media (15).d257a9e9.png";